module.exports = __webpack_public_path__ + "resources/feature-icon-7-c73da5a08afd81410392152dbfb0ee2c.png";


//////////////////
// WEBPACK FOOTER
// ./DeviceNetwork/www/resources/images/feature-icon-7.png
// module id = 73
// module chunks = 0